import { useAsyncExecutor2 } from "async-executor-hook";
import { format } from "date-fns";
import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { map } from "rxjs";

import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import { removeNullUndefinedProps } from "../../common/utils";
import { HTTP_METHODS } from "../../utils/constants";
import { formatDate, formatDateTime, getHHMM } from "../../utils/dates";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatMoney } from "../../utils/numbers";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import {
  ActionsDiv,
  SubtitleDiv,
} from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import AdminDocumentValidationSidebar from "../AdminDocumentValidationSidebar/AdminDocumentValidationSidebar";
import {
  ContainerConfigurate,
  ContainerScroll,
  DivDetailTitle,
} from "../AdminPaymentValidationSidebar/AdminPaymentValidationSidebarStyles";
import {
  InvoiceContainer,
  InvoicesContainer,
  TableHeaderCommon,
} from "../AdminPaymentValidationTable/CommonTable";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import {
  Row,
  TableBody,
  TableHeader,
} from "../DocumentManagement/DocumentManagementSharedStyles";
import { ApproveButton, RejectButton } from "../IconButtons";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import RejectionComment from "../RejectionComment/RejectionComment";
import Sidebar from "../Sidebar/Sidebar";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import { DOCUMENT_TYPE_OPTION } from "./AdminDocumentValidationSearch";
import { DivGenericThird } from "./AdminDocumentValidationStyles";
import {
  DocumenCargoAgentConvertResponse,
  DocumenCreditAuthConvertResponse,
  DocumentElectronicMandateConvertResponse,
  DocumenThirdPartyAgentConvertResponse,
  DocumenThirdPartyBillingConvertResponse,
  DocumentSenasaConvertResponse,
} from "./CommonDocumentValidation";
import AdminDocumentValidationAcceptModal from "./AcceptModal";

const AdminDocumentValidationTable = (props) => {
  const {
    params$,
    onMessageConfirmationChange,
    onTitleConfirmationChange,
    toggleValidationConfirmation,
  } = props;
  const history = useHistory();
  const [typeDocument, setTypeDocument] = useState("");
  const [messageErrorVolantes, setMessageErrorVolantes] = useState("");
  const [showModalErrorVolantes, setShowModalErrorVolantes] = useState(false);
  const loadDocumentType: any = useAsyncExecutor2(
    (params: any) => {
      const selectedOption = DOCUMENT_TYPE_OPTION.find(
        (option) => option.value === params.documentType
      );
      const url = selectedOption.endpoint;

      const endpointParams = {
        ...params,
        documentType: undefined,
        order: "ascending",
      };
      const endpointParamsInvoice = {
        agent_name: params.agent_name,
        from_date: params.from_date,
        order: "descending",
        page: params.page,
        page_size: params.page_size,
        payer_ruc_option:
          params.documentType === "agent_importer"
            ? "consignee"
            : "cargo_agent",
        payment_status_option:
          params.payment_status_option.length > 0
            ? params.payment_status_option
            : [],
        to_date: params.to_date,
        volante_num_list: params.volante_nums,
      };

      const endpointParamsInvoiceThird = {
        payer_ruc_option: "third_party_agency",
        payment_status_option:
          params.payment_status_option.length > 0
            ? params.payment_status_option
            : [],
        agent_name: params.agent_name,
        volante_num_list: params.volante_nums,
        from_date: params.from_date,
        to_date: params.to_date,
        order: "descending",
        page: params.page,
        page_size: params.page_size,
      };

      const endpointParamsMandateElectronic = {
        electronic_mandate_status_option:
          params.electronic_mandate_status_option.length > 0
            ? params.electronic_mandate_status_option
            : [],
        agent_name: params.agent_name,
        from_date: params.from_date,
        to_date: params.to_date,
        order: "ascending",
        page: params.page,
        page_size: params.page_size,
      };
      const endpointParamsSenasa = {
        senasa_status_option:
          params.senasa_status_option.length > 0
            ? params.senasa_status_option
            : [],
        agent_name: params.agent_name,
        from_date: params.from_date,
        to_date: params.to_date,
        order: "ascending",
        page: params.page,
        page_size: params.page_size,
      };

      const convertResponseDictionary = {
        senasa: DocumentSenasaConvertResponse,
        electronic_mandate: DocumentElectronicMandateConvertResponse,
        third_party_billing_authorization:
          DocumenThirdPartyBillingConvertResponse,
        agent_importer: DocumenCreditAuthConvertResponse,
        agent_cargo: DocumenCargoAgentConvertResponse,
        third_party_agency: DocumenThirdPartyAgentConvertResponse,
      };
      if ((params.dam.num && params.notification_status) || params.dam.num) {
        const endpointParams = {
          ...params,
          documentType: undefined,
          order: "ascending",
          dam_num: `235-${params.dam.year}-${params.dam.regimen}-${params.dam?.num}`,
        };
        const endpointParamsSenasa = {
          order: "descending",
          page: params.page,
          page_size: params.page_size,
          agent_name: params.agent_name,
          dam_num: `235-${params.dam.year}-${params.dam.regimen}-${params.dam?.num}`,
          from_date: params.from_date,
          to_date: params.to_date,
          senasa_status_option:
            params.senasa_status_option.length > 0
              ? params.senasa_status_option
              : [],
        };

        const paramsDataDam =
          params.documentType === "agent_importer" ||
          params.documentType === "agent_cargo"
            ? endpointParamsInvoice
            : params.documentType === "third_party_agency"
            ? endpointParamsInvoiceThird
            : params.documentType === "electronic_mandate"
            ? endpointParamsMandateElectronic
            : params.documentType === "senasa"
            ? endpointParamsSenasa
            : endpointParams;
        const cleanedParamsDam = removeNullUndefinedProps(paramsDataDam);
        return networkBackendRequest(
          `${url}?${stringify(cleanedParamsDam)}`,
          HTTP_METHODS.GET,
          undefined,
          undefined
        )
          .then((response) => response.json())
          .then(convertResponseDictionary[params.documentType]);
      }
      const paramsData =
        params.documentType === "agent_importer" ||
        params.documentType === "agent_cargo"
          ? endpointParamsInvoice
          : params.documentType === "third_party_agency"
          ? endpointParamsInvoiceThird
          : params.documentType === "electronic_mandate"
          ? endpointParamsMandateElectronic
          : params.documentType === "senasa"
          ? endpointParamsSenasa
          : endpointParams;

      const cleanedParams = removeNullUndefinedProps(paramsData);

      return networkBackendRequest(
        `${url}?${stringify(cleanedParams)}`,
        HTTP_METHODS.GET,
        undefined,
        undefined
      )
        .then((response) => response.json())
        .then(convertResponseDictionary[params.documentType]);
    },
    {
      params$: params$.pipe(
        map((params: any) => {
          return {
            ...params,
            from_date: format(params.from_date, "yyyy-MM-dd"),
            to_date: format(params.to_date, "yyyy-MM-dd"),
            order: "descending",
            page: params.page ?? 1,
            page_size: ITEMS_PER_PAGE,
          };
        })
      ),
      onSuccess: (_, params) => {
        setTypeDocument(params.documentType);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setMessageErrorVolantes(errorMessage);
        setShowModalErrorVolantes(true);
      },
    }
  );

  const getColumn = (parsedDocumentType) => {
    switch (parsedDocumentType) {
      case "third_party_billing_authorization":
      case "senasa":
      case "electronic_mandate":
      case "third_party_agency":
        return <div>TIPO DE DOCUMENTO</div>;
      case "agent_importer":
        return (
          <div>
            <div>MONTO</div> <div>ID PAGO</div>
          </div>
        );
      default:
        return <div>ID PAGO</div>;
    }
  };

  const gridTemplateColumns =
    typeDocument === "agent_importer" ? `repeat(6, 1fr)` : `repeat(5, 1fr)`;

  const [showRejectionComment, updateShowRejectionComment] = useState(false);
  const [showAskForAction, updateAskForAction] = useState(false);
  const [selectedElement, updateSelectedElement] = useState(null);
  const [selectedStatus, updateSelectedStatus] = useState(null);

  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);
  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  const toggleShowAskForAction = () => {
    updateAskForAction(!showAskForAction);
  };
  const handleAskForAction = (elem, newStatus) => {
    toggleShowAskForAction();
    updateSelectedElement(elem);
    updateSelectedStatus(newStatus);
  };

  const toggleShowRejectionComment = () => {
    updateShowRejectionComment(!showRejectionComment);
  };

  const handleRejectionComment = (elem, newStatus) => {
    toggleShowRejectionComment();
    updateSelectedElement(elem);
    updateSelectedStatus(newStatus);
  };
  const [showSidebar, updateShowSidebar] = useState(false);
  const [sidebarInfo, updateSidebarInfo] = useState<any>({
    agentName: "",
    documentType: "",
    additionalInfo: "",
    documents: [],
  });

  const handleClick = (newSidebarInfo) => {
    updateSidebarInfo(newSidebarInfo);
    updateShowSidebar(true);
  };
  const [useDollars] = useContext(CurrencyContext);

  const approveRejectDocuments = (
    elem,
    newStatus: "approved" | "rejected" | "paid",
    comment = null
  ) => {
    const dataBody = {};
    const info = elem.patchInfo;
    dataBody[info.comment] = comment;
    if (elem.payerRucOption) {
      dataBody[info.paymenStatus] = newStatus;
      dataBody[info.rucOption] = elem.payerRucOption;
      dataBody[info.creditAuthDoc] = elem.documents[0];
    } else {
      dataBody[info.bodyField] = newStatus;
    }

    return networkBackendRequest(
      elem.patchInfo.endpoint,
      HTTP_METHODS.PATCH,
      null,
      dataBody
    )
      .then(() => {
        if (showRejectionComment) toggleShowRejectionComment();
        if (showSidebar) updateShowSidebar(false);
        toggleValidationConfirmation();
        onTitleConfirmationChange(
          newStatus === "paid" || newStatus === "approved"
            ? "Documento validado"
            : "Documento rechazado"
        );
        onMessageConfirmationChange(
          newStatus === "paid" || newStatus === "approved"
            ? "Se ha validado el documento correctamente."
            : "Se ha rechazado el documento."
        );
      })
      .catch((error) => {
        if (showRejectionComment) toggleShowRejectionComment();
        if (showSidebar) updateShowSidebar(false);
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        toggleGetModal();
      });
  };
  const [showSidebarModal, setShowSidebarModal] = useState(false);
  const [showSidebarDetailAproveReject, setShowSidebarDetailAproveReject] =
    useState(false);
  const closeSideDetail = () => {
    setShowSidebarDetailAproveReject(!showSidebarDetailAproveReject);
  };
  const closeSideInfo = () => {
    setShowSidebarModal(!showSidebarModal);
  };
  const gridTemplateColumnsSidebar = "2fr 1fr 1fr 2fr";
  return (
    <div>
      <div>
        {messageErrorVolantes && showModalErrorVolantes && (
          <ConfirmationModal
            message={messageErrorVolantes}
            onAccept={() => {
              setShowModalErrorVolantes(false);
            }}
            title={`Atención`}
            toggleModal={() => {
              setShowModalErrorVolantes(false);
            }}
          />
        )}
        {showModalError && messageError && (
          <ConfirmationModal
            message={messageError}
            onAccept={() => {
              toggleGetModal();
            }}
            title={`Atención`}
            toggleModal={() => {
              toggleGetModal();
            }}
          />
        )}
        {loadDocumentType.isError && (
          <div>
            Algo salió mal
            <button
              type="button"
              onClick={() => {
                loadDocumentType.retry();
              }}
            >
              Reintentar
            </button>
          </div>
        )}
        {loadDocumentType.status === "PROCESSING" && (
          <div style={{ marginRight: "2rem", marginLeft: "2rem" }}>
            <PaymentLoader numItems={ITEMS_PER_PAGE} />
          </div>
        )}
        {loadDocumentType.isSuccess && (
          <div>
            {loadDocumentType.data.data_document.length === 0 && (
              <StandaloneMessage>
                No se encontraron documentos a validar con los parámetros
                brindados.
              </StandaloneMessage>
            )}

            {typeDocument !== "agent_importer" &&
            typeDocument !== "agent_cargo" &&
            typeDocument !== "third_party_agency" ? (
              <div>
                {loadDocumentType.data.data_document.length > 0 && (
                  <div>
                    <TableHeader gridTemplateColumns={gridTemplateColumns}>
                      <div className="left-align">AGENTE DE ADUANA</div>
                      <div>CONSIGNATARIO</div>
                      {getColumn(typeDocument)}
                      <div>FECHA DE SUBIDA</div>
                      <div>ACCIONES</div>
                    </TableHeader>
                    <TableBody gridTemplateColumns={gridTemplateColumns}>
                      {loadDocumentType.data.data_document.map((elem) => (
                        <Row
                          key={elem.id}
                          onClick={() => handleClick(elem)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="left-align">
                            <div>{elem.agentName}</div>
                            {elem.documents && (
                              <SubtitleDiv>
                                {elem.documents.length > 1
                                  ? `${elem.documents.length} documentos`
                                  : "1 documento"}
                              </SubtitleDiv>
                            )}
                          </div>
                          <div>{elem.consigneeName}</div>
                          {typeDocument === "agent_importer" ? (
                            <div>
                              <div>
                                {formatMoney(
                                  elem.salesInvoiceTotal,
                                  useDollars
                                )}
                              </div>
                              <div>{elem.idPayment}</div>
                            </div>
                          ) : (
                            <div>
                              <b>{elem.documentType.toUpperCase()}</b>
                            </div>
                          )}
                          <div>{formatDateTime(elem.uploadDate)}</div>
                          <Authorization
                            actions={[
                              "dam.update_dam_senasa_admin",
                              "dam.update_dam_electronic_mandate",
                              "volante.update_volante_third_party_auth",
                              "invoice.get_invoice_credit_cargo_agent_and_consignee",
                              "invoice.get_invoice_estimate_cargo_agent_and_consignee",
                            ]}
                          >
                            <>
                              {elem.status === "pending" ||
                                (elem.status === "reviewing" && (
                                  <ActionsDiv>
                                    <ApproveButton
                                      tooltipText="Aprobar documento"
                                      onClick={(ev) => {
                                        ev.stopPropagation();

                                        handleAskForAction(elem, "approved");
                                      }}
                                    />
                                    <RejectButton
                                      tooltipText="Rechazar documento"
                                      onClick={(ev) => {
                                        ev.stopPropagation();
                                        handleRejectionComment(
                                          elem,
                                          "rejected"
                                        );
                                      }}
                                    />
                                  </ActionsDiv>
                                ))}
                            </>
                          </Authorization>
                        </Row>
                      ))}
                    </TableBody>

                    <div className="flex-paginator">
                      <Paginator
                        first={
                          (loadDocumentType.params.page - 1) *
                          loadDocumentType.data.pageSize
                        }
                        rows={loadDocumentType.data.pageSize}
                        totalRecords={loadDocumentType.data.count}
                        onPageChange={(e) => {
                          const targetPage =
                            e.first / loadDocumentType.data.pageSize;
                          const pathname = history.location.pathname;
                          const parsedParams = parse(history.location.search);
                          const stringifiedParams = stringify({
                            ...parsedParams,
                            page: targetPage + 1,
                          });
                          history.push(`${pathname}?${stringifiedParams}`);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div>
                {loadDocumentType.data.data_document.length > 0 && (
                  <div>
                    <TableHeader gridTemplateColumns={"repeat(6, 1fr)"}>
                      <div className="left-align">AGENTE DE ADUANA</div>
                      <div>
                        {typeDocument === "agent_importer"
                          ? "IMPORTADOR"
                          : typeDocument === "third_party_agency"
                          ? "CRÉDITO DE TERCEROS"
                          : "AGENTE DE CARGA"}
                      </div>
                      <div>MONTO</div>
                      <div>ID PAGO</div>
                      <div>FECHA DE SUBIDA</div>
                      <div>ACCIONES</div>
                    </TableHeader>
                    <TableBody gridTemplateColumns={"repeat(6, 1fr)"}>
                      {loadDocumentType.data.data_document.map((elem) => (
                        <Row
                          key={elem.id}
                          onClick={() => handleClick(elem)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="left-align">
                            <div>{elem.agentName}</div>
                            <SubtitleDiv>1 documento</SubtitleDiv>
                          </div>
                          <div>{elem.consigneeName}</div>
                          <div>
                            {formatMoney(elem.salesInvoiceTotal, useDollars)}
                          </div>
                          <div>{elem.idPayment}</div>
                          <div>
                            <div>{formatDate(elem.uploadDate)}</div>
                            <div style={{ marginLeft: 5 }}>
                              A LAS {getHHMM(elem.uploadDate)}
                            </div>
                          </div>
                          <Authorization
                            actions={[
                              "dam.update_dam_senasa_admin",
                              "dam.update_dam_electronic_mandate",
                              "volante.update_volante_third_party_auth",
                              "invoice.get_invoice_estimate_cargo_agent_and_consignee",
                            ]}
                          >
                            {(elem.paymentStatusOption === "pending_payment" ||
                              elem.paymentStatusOption ===
                                "pending_validation") && (
                              <ActionsDiv>
                                <ApproveButton
                                  tooltipText="Aprobar documento"
                                  onClick={() => {
                                    handleClick(elem);
                                  }}
                                />
                                <RejectButton
                                  tooltipText="Rechazar documentos"
                                  onClick={() => {
                                    handleClick(elem);
                                  }}
                                />
                              </ActionsDiv>
                            )}
                          </Authorization>
                        </Row>
                      ))}
                    </TableBody>
                    <div className="flex-paginator">
                      <Paginator
                        first={
                          (loadDocumentType.params.page - 1) *
                          loadDocumentType.data.pageSize
                        }
                        rows={loadDocumentType.data.pageSize}
                        totalRecords={loadDocumentType.data.count}
                        onPageChange={(e) => {
                          const targetPage =
                            e.first / loadDocumentType.data.pageSize;
                          const pathname = history.location.pathname;
                          const parsedParams = parse(history.location.search);
                          const stringifiedParams = stringify({
                            ...parsedParams,
                            page: targetPage + 1,
                          });
                          history.push(`${pathname}?${stringifiedParams}`);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {showSidebarModal && (
          <Sidebar onOutsideClick={closeSideInfo}>
            <ContainerScroll>
              <ContainerConfigurate width="84.2rem" minHeight="auto">
                <DivDetailTitle fontSize="2rem">
                  Detalles del documento
                </DivDetailTitle>
                <InvoicesContainer
                  gridTemplateColumns={gridTemplateColumnsSidebar}
                >
                  <TableHeaderCommon className="item-container">
                    <div
                      className="main-info-header"
                      style={{ marginLeft: "2rem" }}
                    >
                      {"DAM"}
                    </div>
                    <div>{"AWB"}</div>
                    <div>{"HAWB"}</div>
                    <div>{"VOLANTE"}</div>
                  </TableHeaderCommon>
                  <div
                    style={{ overflowY: "scroll", maxHeight: "21.1vh" }}
                    className="scroll"
                  >
                    {sidebarInfo &&
                      sidebarInfo.volantes.map((elem) => {
                        return (
                          <div
                            key={elem.volante_num}
                            style={{ cursor: "pointer" }}
                          >
                            <InvoiceContainer
                              className="item-container"
                              height="7rem"
                            >
                              <div className="attribute main-info-header">
                                <div className="titles">{"DAM"}</div>
                                <div className="main-info-header">
                                  <div className="left-align">
                                    {sidebarInfo.damNum || elem.dam_num}
                                  </div>
                                </div>
                              </div>
                              <div className="attribute">
                                <div className="titles">{"AWB"}</div>
                                <div>{elem.master_air_waybill}</div>
                              </div>
                              <div className="attribute">
                                <div className="titles">{"HAWB"}</div>
                                <div className="left-align">
                                  {elem.house_air_waybill}
                                </div>
                              </div>
                              <div className="attribute">
                                <div className="titles">{"VOLANTE"}</div>
                                <div>{elem.volante_num}</div>
                              </div>
                            </InvoiceContainer>
                          </div>
                        );
                      })}
                  </div>
                </InvoicesContainer>
              </ContainerConfigurate>
            </ContainerScroll>
          </Sidebar>
        )}
        {showSidebarDetailAproveReject && (
          <Sidebar onOutsideClick={closeSideDetail}>
            <ContainerScroll>
              <ContainerConfigurate
                width={sidebarInfo.status === "approved" ? "45rem" : "49rem"}
                borderRadius="8px"
              >
                <DivDetailTitle fontSize="2rem">
                  {sidebarInfo.status === "approved"
                    ? "Detalle de aprobación"
                    : "Detalle de rechazo"}
                </DivDetailTitle>
                <DivGenericThird
                  marginTop="2.9rem"
                  fontSize="1.4rem"
                  fontWeight={700}
                  color="rgba(46, 53, 61, 0.3)"
                >
                  {sidebarInfo.status === "approved"
                    ? "USUARIO APROBADOR"
                    : "USUARIO RECHAZADOR"}
                </DivGenericThird>
                <DivGenericThird
                  marginTop="0.8rem"
                  fontSize="1.4rem"
                  fontWeight={500}
                  color="#2E353D"
                >
                  {sidebarInfo.emailThird}
                </DivGenericThird>
                <DivGenericThird
                  marginTop="3.1rem"
                  fontSize="1.4rem"
                  fontWeight={700}
                  color="rgba(46, 53, 61, 0.3)"
                >
                  {sidebarInfo.status === "approved"
                    ? "FECHA / HORA DE APROBACIÓN"
                    : "FECHA / HORA DE RECHAZO"}
                </DivGenericThird>
                <DivGenericThird
                  marginTop="0.8rem"
                  fontSize="1.4rem"
                  fontWeight={500}
                  color="#2E353D"
                >
                  {format(new Date(sidebarInfo.uploadDate), "dd/MM/yyyy")},{" "}
                  {format(new Date(sidebarInfo.uploadDate), "HH:mm:ss")}
                </DivGenericThird>
                {sidebarInfo.status === "rejected" && (
                  <>
                    <DivGenericThird
                      marginTop="2.2rem"
                      fontSize="1.4rem"
                      fontWeight={700}
                      color="rgba(46, 53, 61, 0.3)"
                    >
                      MOTIVO DE RECHAZO
                    </DivGenericThird>
                    <DivGenericThird
                      marginTop="0.8rem"
                      fontSize="1.4rem"
                      fontWeight={500}
                      color="#2E353D"
                    >
                      {sidebarInfo.commentThird}
                    </DivGenericThird>
                  </>
                )}
              </ContainerConfigurate>
            </ContainerScroll>
          </Sidebar>
        )}
        {showSidebar && (
          <AdminDocumentValidationSidebar
            sidebarInfo={sidebarInfo}
            documentTypeNumb={typeDocument}
            onOutsideClick={() => updateShowSidebar(false)}
            handleRejectionComment={handleRejectionComment}
            handleAskForAction={handleAskForAction}
            typeDocument={typeDocument}
            setShowSidebarModal={setShowSidebarModal}
            setShowSidebarDetailAproveReject={setShowSidebarDetailAproveReject}
          />
        )}

        <Authorization
          actions={[
            "invoice.update_credit_cargo_agent_and_consignee",
            "dam.update_dam_senasa_admin",
            "dam.update_dam_electronic_mandate",
            "volante.update_volante_third_party_auth",
          ]}
        >
          {showRejectionComment && (
            <RejectionComment
              toggleModal={toggleShowRejectionComment}
              title="Rechazar documento"
              onReject={(comment) =>
                approveRejectDocuments(selectedElement, selectedStatus, comment)
              }
            />
          )}
          {showAskForAction && (
            <AdminDocumentValidationAcceptModal
              toggleModal={toggleShowAskForAction}
              damInfo={selectedElement}
              onApprove={(comment) =>
                approveRejectDocuments(selectedElement, selectedStatus, comment)
              }
            />
          )}
        </Authorization>
      </div>
    </div>
  );
};
export default AdminDocumentValidationTable;
